var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point",style:({'left': `${_vm.pointer.coordinates.x}%`, 'top': `${_vm.pointer.coordinates.y}%`})},[_c('span',[_vm._v(_vm._s(_vm.pointer.value))]),_c('v-icon',{staticClass:"point__delete",on:{"click":function($event){return _vm.$emit('delete')}}},[_vm._v("mdi-close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }